module.exports = __webpack_public_path__ + "img/payment-type-visa.bf2de723.svg";